import logo from './logo.svg';
import './App.css';
import React, { useEffect, useRef, useState } from "react";
import styled from 'styled-components';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-regular-svg-icons";
import { faFacebook, faTwitter, faInstagram, faGithub, faYoutube, faWhatsapp } from "@fortawesome/free-brands-svg-icons";


<link href="https://fonts.googleapis.com/css2?family=Kumar+One&display=swap" rel="stylesheet" />



function App() {
  const StyledWrapper = styled.div`
  .bubble {
    position: absolute;
    left:10px;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    box-shadow: inset 0 0 25px rgba (255, 255, 255, 0.25);
    animation: animate_4010 8s ease-in-out infinite;
  }

  .bubble:nth-child(2) {
    position: relative;
    zoom: 0.45;
    left: -10px;
    top: -100px;
    animation-delay: -4s;
  }

  .bubble:nth-child(3) {
    position: relative;
    zoom: 0.45;
    right: -80px;
    top: -300px;
    animation-delay: -6s;
  }

  .bubble:nth-child(4) {
    position: relative;
    zoom: 0.35;
    left: -120px;
    bottom: -200px;
    animation-delay: -3s;
  }

  .bubble:nth-child(5) {
    position: relative;
    zoom: 0.5;
    left: 0px;
    top: 200px;
    animation-delay: -5s;
  }

  @keyframes animate_4010 {
    0%,100% {
      transform: translateY(-20px);
    }

    50% {
      transform: translateY(20px);
    }
  }

  .bubble::before {
    content: '';
    position: absolute;
    top: 50px;
    left: 45px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #fff;
    z-index: 10;
    filter: blur(2px);
  }

  .bubble::after {
    content: '';
    position: absolute;
    top: 80px;
    left: 80px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #fff;
    z-index: 10;
    filter: blur(2px);
  }

  .bubble span {
    position: absolute;
    border-radius: 50%;
    // background-color: yellow;
  }

  .bubble span:nth-child(1) {
    inset: 10px;
    border-left: 15px solid #0fb4ff;
    filter: blur(8px);
  }

  .bubble span:nth-child(2) {
    inset: 10px;
    border-right: 15px solid #ff4484;
    filter: blur(8px);
  }

  .bubble span:nth-child(3) {
    inset: 10px;
    border-top: 15px solid #ffeb3b;
    filter: blur(8px);
  }

  .bubble span:nth-child(4) {
    inset: 30px;
    border-left: 15px solid #ff4484;
    filter: blur(12px);
  }
    .container {
    width: 100%;
    // background-color: blue;
    }

  .bubble span:nth-child(5) {
    inset: 10px;
    border-bottom: 10px solid #fff;
    filter: blur(8px);
    transform: rotate(330deg);
  }`;
  const [showMessage, setShowMessage] = useState(false)
  const [viewMessage, setViewMessage] = useState(true)
  const [viewLoading, setViewLoading] = useState(false)
  const [animateForm, setIsAnimateForm] = useState(false)
  const [name, setName] = useState("");

  const handleChange = (event) => {
    setName(event.target.value); 
  };


    const viewMe = () => {
      if(name === ''){

      }else{
        setViewLoading(true)
        setViewMessage(false)        
        setTimeout(() => {
          setShowMessage(true)
          setIsAnimateForm(true)
        setViewLoading(false)
        // setViewMessage(true)        


        },3000)

      }
    }
    // const [quote, setQuote] = useState("");
  
    // useEffect(() => {
    //   fetchQuote();
    // }, []);
  
    // const fetchQuote = async () => {
    //   try {
    //     const response = await fetch("https://love-quotes-by-lovemelon.p.rapidapi.com/", {
    //       method: "GET",
    //       headers: {
    //         "x-rapidapi-host": "love-quotes-by-lovemelon.p.rapidapi.com",
    //         "x-rapidapi-key": "e96361371emshd2a743e49c4444cp1f9242jsn36495cfc2c85", 
    //       },
    //     });
  
    //     const data = await response.json();
    //     setQuote(data.quote); // Assuming the API response has a "quote" field
    //   } catch (error) {
    //     console.error("Error fetching quote:", error);
    //   }
    // };





    // const [quote, setQuote] = useState('');
    // const [author, setAuthor] = useState('');
    
    // useEffect(() => {
    //   fetchLoveQuote();
    // }, []);
    
    // const fetchLoveQuote = async () => {
    //   try {
    //     const response = await fetch('pub_709711ffd086653849d33acddc503fc36cee7');
    //     if (!response.ok) {
    //       throw new Error(`An error occurred: ${response.statusText}`);
    //     }
    //     const data = await response.json();
    
    //     console.log("API Response:", data);
    
    //     const selectedQuote = data[0]; // ✅ ZenQuotes API returns an array
    
    //     setQuote(selectedQuote.q);
    //     setAuthor(selectedQuote.a);
    //   } catch (error) {
    //     console.error('Error fetching the love quote:', error);
    //   }
    // };
    

    const [quote, setQuote] = useState('Loading...'); // ✅ Default value to prevent empty UI

    useEffect(() => {
        fetchLoveQuote();
    }, []);

    const fetchLoveQuote = async () => {
        try {
            const response = await fetch('https://love-quote.p.rapidapi.com/lovequote', {
                method: 'GET',
                headers: {
                    'x-rapidapi-key': 'e96361371emshd2a743e49c4444cp1f9242jsn36495cfc2c85',
                    'x-rapidapi-host': 'love-quote.p.rapidapi.com'
                }
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }

            const data = await response.json();
            console.log('API Response:', data);

            setQuote(data.quote); // ✅ Update state with received quote
        } catch (error) {
            console.error('Error fetching love quote:', error);
            setQuote('Failed to load quote.');
        }
    };

    
  return (
    <div className="App">

   
   <StyledWrapper>
      <div className="container">
        <div className="bubble">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <div className="bubble">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <div className="bubble">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <div className="bubble">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <div className="bubble">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    </StyledWrapper>
    <div className="valBegins2">
    <div className="valBegins">
    <h1 className='valHeading'>HAPPY VALENTINE</h1>
    {/* <FontAwesomeIcon icon={faHeart} /> */}

<div class="heart-container" title="Like">
            <input type="checkbox" class="checkbox" id="Give-It-An-Id" />
            <div class="svg-container">
                <svg viewBox="0 0 24 24" class="svg-outline" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Zm-3.585,18.4a2.973,2.973,0,0,1-3.83,0C4.947,16.006,2,11.87,2,8.967a4.8,4.8,0,0,1,4.5-5.05A4.8,4.8,0,0,1,11,8.967a1,1,0,0,0,2,0,4.8,4.8,0,0,1,4.5-5.05A4.8,4.8,0,0,1,22,8.967C22,11.87,19.053,16.006,13.915,20.313Z">
                    </path>
                </svg>
                <svg viewBox="0 0 24 24" class="svg-filled" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Z">
                    </path>
                </svg>
                <svg class="svg-celebrate" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                    <polygon points="10,10 20,20"></polygon>
                    <polygon points="10,50 20,50"></polygon>
                    <polygon points="20,80 30,70"></polygon>
                    <polygon points="90,10 80,20"></polygon>
                    <polygon points="90,50 80,50"></polygon>
                    <polygon points="80,80 70,70"></polygon>
                </svg>
            </div>
        </div>
        </div>
    </div>



<div className={`valForm ${animateForm ? 'goBackIn' : ''}`}>
    <div class="subscribe">
    <p>Your Name</p>
    <input placeholder="your name" 
    class="subscribe-input" 
    type="text"
    value={name}  
    onChange={handleChange}/>
    <br />
    <div class="submit-btn" onClick={viewMe}>
      {viewMessage && (
        <div className="mmm">
  VIEW MESSAGE
</div>
      )}

{viewLoading && (
<div class="dot-spinner">
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
</div>
)}
    </div>
  </div>
         </div>


{showMessage && (
<div className="textPart">
<div class="container2">
 <p> Dear {name},  {quote}

  Forever Yours...
 </p>

</div>
</div>
)}



<div className="above">
  <p></p>
</div>

<div className="socials">
  <div className="lit">
  Lit_Codes1 | Est 2025
  </div>
<a href="https://wa.me/2349077277666" target="_blank" className="faceBook">
  <FontAwesomeIcon icon={faWhatsapp} />
  </a>

  <a href='https://www.instagram.com/heis__lit/' target="_blank" className="faceBook">
  <FontAwesomeIcon icon={faInstagram} />
  </a>
  </div>


    </div>
    
  );
}


export default App;
